import { request } from '@/common/services/request';

const RESOURCE_FIELDS = [
  'platform',
  'accountId',
  'contentId',
  'contentTitle',
  'likeCount',
  'detailDoc',
  'reviewStatus',
];

const getPayloadData = (payload) => payload?.data || payload || {};

const getResourceData = (input) =>
  RESOURCE_FIELDS.reduce(
    (data, field) => ({
      ...data,
      [field]: input[field],
    }),
    {},
  );

const toProTableResult = (result) => ({
  data: result.data || [],
  success: true,
  total: result.meta?.total || 0,
});

const getQueryParams = (params = {}) =>
  Object.fromEntries(
    Object.entries({
      organizationId: params.organizationId,
      accountId: params.accountId,
      contentId: params.contentId,
      contentTitle: params.contentTitle,
      platform: params.platform,
      current: params.current,
      page: params.page,
      pageSize: params.pageSize,
    }).filter(([, value]) => value !== undefined),
  );

export async function queryHotRadars(params) {
  const result = await request('/api/trace/tenant/hot-radars', {
    method: 'GET',
    params: getQueryParams(params),
  });
  return toProTableResult(result);
}

export async function queryHotRadarAccounts(params) {
  const result = await request('/api/trace/tenant/accounts', {
    method: 'GET',
    params: {
      organizationId: params?.organizationId,
      current: 1,
      pageSize: 100,
    },
  });
  return result.data || [];
}

export async function getHotRadar(payload) {
  const data = getPayloadData(payload);
  return request('/api/trace/tenant/hot-radars', {
    method: 'GET',
    params: {
      id: data.id,
      organizationId: data.organizationId,
    },
  });
}

export async function createHotRadar(payload) {
  const data = getPayloadData(payload);
  return request('/api/trace/tenant/hot-radars', {
    method: 'POST',
    params: {
      organizationId: data.organizationId,
    },
    data: getResourceData(data),
  });
}

export async function updateHotRadar(payload) {
  const data = getPayloadData(payload);
  return request('/api/trace/tenant/hot-radars', {
    method: 'PUT',
    params: {
      id: data.id,
      organizationId: data.organizationId,
    },
    data: getResourceData(data),
  });
}

export async function removeHotRadar(payload) {
  const data = getPayloadData(payload);
  return request('/api/trace/tenant/hot-radars', {
    method: 'DELETE',
    params: {
      id: data.id,
      organizationId: data.organizationId,
    },
  });
}

export async function createHotRadarFromContentLog(payload) {
  const data = getPayloadData(payload);
  return request('/api/agents/runs', {
    method: 'POST',
    params: {
      organizationId: data.organizationId,
    },
    data: {
      agentId: 'hot-radar',
      payload: { recordId: data.id },
    },
  });
}
